import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "text-h6" }

import { computed, ref, watch } from "vue";
import { Item } from "../model/Item";
import { useTagStore } from "@/modules/tag/model/TagService";
import { TagFactory } from "@/modules/tag/model/TagFactory";
import TagSearchField from "@/modules/item/components/TagSearchField.vue"

import { container } from "@/system/container";
import { TOKENS } from "@/system/tokens";
import useQuasar from 'quasar/src/composables/use-quasar.js';;


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDialog',
  props: ["valueModel", "item"],
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }) {

const props = __props;

const itemService = container.get(TOKENS.itemService);
const tagService = container.get(TOKENS.tagService);
const tagFactory = new TagFactory();
const tagStore = useTagStore();
let original: string
const options = ref();
const item = ref()
const isValid = ref<boolean>(true)

const $q = useQuasar()




watch(props, () => {
  if (!original) 
    original = JSON.stringify(props.item)
  
  item.value = JSON.parse(original)
})

const showDialog = computed({
  get() {
    return props.valueModel
  },
  set(value) {
    emits("update:modelValue", value)
  }
})

const filterFn = (val: string, update: any, abort: any) => {
  update(() => {
    const needle = val.toLowerCase();
    const values = tagStore.filterTags(needle);
    const v = values.filter((x) => {
      return item.value.tags.indexOf(x) === -1;
    });
    options.value = v;
  });
};

const requiredField = (val: string) => {
  return (!!val || 'Required field')
}

const validateURL = (val: string) => {
  try {
    const adr = new URL(val)
  } catch {
    return "Invalid URL"
  }
}


const save = async () => {
  var message = ""
  var type = 'positive'
  try {
    if ("id" in item.value) {
      await itemService.update(item.value);
      message = 'Keep updated!'
    } else {
      await itemService.create(item.value);
      message = 'Keep created!'
    }
    showDialog.value = false
  } catch (e) {
    if ("id" in item.value) {
      item.value = JSON.parse(original)
    }
    message = e.message
    type = 'negative'
  }
  $q.notify({ message: message, type: type })
};

const deleteItem = async () => {
  var message = 'Keep deleted'
  var type = 'positive'
  try {
    await itemService.remove(item.value);
    showDialog.value = false
  } catch (e) {
    message = e.message
    type = 'negative'
  }
  $q.notify({ message: message, type: type })
};

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      (item.value)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            style: {"width":"100%","max-width":"35rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(item.value.id ? "Update Keep" : "New Keep"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    modelValue: item.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.title) = $event)),
                    type: "text",
                    label: "Title",
                    hint: "Enter a title",
                    rules: [ requiredField ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    modelValue: item.value.url,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.url) = $event)),
                    type: "url",
                    label: "URL",
                    hint: "Enter link to the site",
                    rules: [ requiredField, validateURL ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(TagSearchField, {
                    modelValue: item.value.tags,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.tags) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    modelValue: item.value.description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.description) = $event)),
                    label: "Description",
                    hint: "Describe this item",
                    autogrow: "",
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { align: "between" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    flat: "",
                    rounded: "",
                    label: "Cancel",
                    color: "$grey-5"
                  }, null, 512), [
                    [_directive_close_popup]
                  ]),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    rounded: "",
                    label: item.value.id ? 'Update' : 'Save',
                    color: "positive",
                    onClick: save
                  }, null, 8, ["label"]),
                  (item.value.id)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        flat: "",
                        rounded: "",
                        label: "Delete",
                        color: "negative",
                        onClick: deleteItem
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})